import React, { Component } from "react";
import { Grid, Row, Col } from "react-app-flexbox-grid";
import Loader from "../Loader/Loader";
import Error from "../Error/Error";
import "./LiquidityPool.css";
import { getLiquidityPool } from "../../fetch";
import { network } from "../Network";
import Table from "../Table/Table";

class LiquidityPool extends Component {
  constructor(props) {
    super(props);
    let data = props.params.data;
    let error = props.params.error;
    if (data == null) {
      if (
        typeof window !== "undefined" &&
        window != null &&
        window.__INITIAL_STATE__ != null &&
        window.__INITIAL_STATE__.data != null
      ) {
        data = window.__INITIAL_STATE__.data;
        window.__INITIAL_STATE__.data = null;
      }
    }
    if (error == null) {
      if (
        typeof window !== "undefined" &&
        window != null &&
        window.__INITIAL_STATE__ != null &&
        window.__INITIAL_STATE__.error != null
      ) {
        error = window.__INITIAL_STATE__.error;
        window.__INITIAL_STATE__.error = null;
      }
    }
    this.state = {
      id: props.params.id,
      load: data == null && error == null,
      error: error,
      liquidity_pool: data,
    };
  }

  componentDidMount() {
    if (this.state.liquidity_pool == null && this.state.error == null) {
      this.load();
    }
  }

  componentDidUpdate() {
    if (this.state.id !== this.props.params.id) {
      this.setState({
        id: this.props.params.id,
        load: true,
        error: null,
        liquidity_pool: null,
      });
      this.load(this.props.params.id);
    }
  }

  load(id) {
    if (this.state.load === false) {
      this.setState({ load: true });
    }
    if (id == null) {
      id = this.state.id;
    }
    getLiquidityPool(
      id,
      (data) => {
        this.setState({
          load: false,
          error: data.error,
          liquidity_pool: data.data,
        });
      },
      network
    );
  }

  render() {
    if (this.state.liquidity_pool != null) {
      var summary;

      summary = {
        headers: [{ width: "40%" }, { width: "60%", align: "right" }],
        items: [
          [
            { text: this.state.liquidity_pool.reserves[0].asset },
            { text: this.state.liquidity_pool.reserves[0].amount },
          ],
          [
            { text: this.state.liquidity_pool.reserves[1].asset },
            { text: this.state.liquidity_pool.reserves[0].amount },
          ],
        ],
      };
    }
    return (
      <Grid fluid className="liquidity-pool">
        {this.state.load && <Loader />}
        {this.state.liquidity_pool != null && (
          <Row>
            <Col xs={12} md={12}>
              <div className="liquidity-pool-block">
                <h2 className="liquidity-pool-title">Liquidity Pool</h2>
                <div className="liquidity-pool-value">
                  {this.state.liquidity_pool.id}
                </div>
              </div>
            </Col>
            <Col xs={12} md={12} className="over">
              <div className="liquidity-pool-block">
                <h2 className="liquidity-pool-title">Pool Reserves</h2>
                <Table data={summary} />
              </div>
            </Col>
          </Row>
        )}
        {this.state.error != null && <Error message={this.state.error} />}
      </Grid>
    );
  }
}

export default LiquidityPool;



// WEBPACK FOOTER //
// ./src/components/LiquidityPool/LiquidityPool.js